// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const onlyUnique = (value: any, index: number, self: any) => self.indexOf(value) === index;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const onlyUniqueNonBlank = (value: any, index: number, self: any) => !!value && onlyUnique(value, index, self);

export const SumNumber = (array: number[]): number => array.reduce((a, b) => a + b, 0);
